var map = {
	"./apple-laurel-da-DK.svg": 70923,
	"./apple-laurel-de-DE.svg": 90265,
	"./apple-laurel-en-GB.svg": 98579,
	"./apple-laurel-en-US.svg": 41740,
	"./apple-laurel-es-ES.svg": 26475,
	"./apple-laurel-es-MX.svg": 10328,
	"./apple-laurel-fr-FR.svg": 27983,
	"./apple-laurel-it-IT.svg": 24273,
	"./apple-laurel-nb-NO.svg": 23026,
	"./apple-laurel-nl-NL.svg": 89031,
	"./apple-laurel-pl-PL.svg": 26571,
	"./apple-laurel-pt-BR.svg": 18403,
	"./apple-laurel-pt-PT.svg": 46443,
	"./apple-laurel-sv-SE.svg": 63594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;